// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__HEDZY","content":"RecentSearches_content__xdGtV"};